import { server } from '@/api'

export const record = async (viewableType, viewableId) => {
    return await server().post('api/views/record', {
        viewable_type: viewableType,
        viewable_id: viewableId,
    })
}

export const analytics = async (params = {}) => {
    return await server().get('api/dashboard/admin/view-analytics', { params })
}

export default { record, analytics }
